import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"

const useStyles = makeStyles({
	flowResponseHeaderText: {
		color: `${colors.gray[950]}80`,
		lineHeight: 1.5
	},
	flowResponseText: {
		color: `${colors.gray[950]}80`,
		fontStyle: "italic",
		lineHeight: 1.5
	},
	flowResponseLine: {
		display: "block"
	}
})

export default useStyles
